// frontend/src/components/CodeEntry.tsx
import { useState, KeyboardEvent } from 'react'
import axios from 'axios'
import { Loader2 } from 'lucide-react'
import './CodeEntry.css'

export interface HandoffResponse {
  job_id: string
  result?: any
  source?: string
  expires_in_seconds?: number
}

interface CodeEntryProps {
  onLoaded: (jobData: HandoffResponse) => void
}

export function CodeEntry({ onLoaded }: CodeEntryProps) {
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const normalized = code.replace(/[^A-Z0-9]/gi, '').toUpperCase()
  const isValid = normalized.length === 8

  const handleLoad = async () => {
    if (!isValid || loading) return
    setLoading(true)
    setError(null)
    try {
      const resp = await axios.post('/api/handoff/load', { code: code })
      onLoaded(resp.data)
    } catch (e) {
      if (axios.isAxiosError(e) && e.response?.status === 404) {
        setError('Code ungültig oder abgelaufen.')
      } else {
        setError('Fehler beim Laden. Bitte erneut versuchen.')
      }
    } finally {
      setLoading(false)
    }
  }

  const handleKey = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') handleLoad()
  }

  return (
    <div className="code-entry-box">
      <div className="code-entry-label">📱 Von der App wechseln</div>
      <div className="code-entry-title">App-Code eingeben</div>
      <p className="code-entry-sub">
        Chat in der App geteilt? Code eingeben um auf Desktop weiterzumachen&nbsp;— mit allen Optionen.
      </p>
      <div className="code-input-row">
        <input
          className="code-input"
          aria-label="App-Code eingeben"
          value={code}
          onChange={(e) => {
            const raw = e.target.value.replace(/[^A-Z0-9a-z]/g, '').toUpperCase().slice(0, 8)
            const fmt = raw.length > 4 ? raw.slice(0, 4) + '-' + raw.slice(4) : raw
            setCode(fmt)
            setError(null)
          }}
          onKeyDown={handleKey}
          placeholder="A7K2-PX3Q"
          maxLength={9}
          spellCheck={false}
          autoCapitalize="characters"
        />
        <button
          className="code-load-btn"
          onClick={handleLoad}
          disabled={!isValid || loading}
        >
          {loading ? <Loader2 size={16} className="spinning" /> : 'Laden →'}
        </button>
      </div>
      {error && <p className="code-entry-error">{error}</p>}
    </div>
  )
}
